import { Box, TextField } from "@mui/material";

const EditEmail = ({
  email,
  lead,
  isError,
  autoFocus,
}: {
  email: any;
  lead: any;
  isError: boolean;
  autoFocus?: boolean;
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <TextField
        sx={{
          width: "100%",
          borderRadius: "4px",
        }}
        error={isError || email.isError || email.showError}
        helperText={email.showError ? "Invalid email format" : ""}
        autoFocus={autoFocus}
        onChange={email.handleChangeEmail}
        label={"Email"}
        size="small"
        defaultValue={lead?.data?.lead?.email || ""}
      />
    </Box>
  );
};

export default EditEmail;
